export const CREATE_USERS = 'CREATE_USERS';
export const DELETE_USERS = 'DELETE_USERS';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ID_USERS = 'GET_ID_USERS';
export const SEARCH_USERS = 'SEARCH_USERS';
export const UPDATE_USERS = 'UPDATE_USERS';

export const USER_ROLES = {
    ADMIN: 'Admin',
    MANAGER: 'Manager',
    USER: 'User'
};

export const USER_STATUSES = {
    ACTIVE: 'Active',
    INACTIVE: 'Inactive',
    PENDING: 'Pending'
};
